@if (permittedToUpgrade()) {
  @switch (upgradeTo()) {
    @case (UpgradeTo.PRO) {
      <a
        pButton
        [href]="upgradeUrl()"
        target="_blank"
        severity="contrast"
        size="small"
      >
        <i pButtonIcon class="{{ PrimeIcons.STAR }}"></i>
        <span pButtonLabel>Upgrade</span>
      </a>
    }
    @case (UpgradeTo.ENTERPRISE) {
      Contact sales to upgrade your plan:
      <a
        [href]="'mailto:' + salesEmailAddress"
        style="color: white; white-space: nowrap; text-decoration: underline"
      >
        {{ salesEmailAddress }}
      </a>
    }
  }
} @else {
  Contact your team administrator to upgrade your plan.
}
